import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const faqs = [
  { q: "Wat is het minimale aantal stuks dat ik kan bestellen?", a: "Wij bedrukken vanaf 10 stuks. Voor borduurwerk 25 stuks — neem contact op voor de mogelijkheden." },
  { q: "Kunnen jullie ook grote aantallen aan?", a: "Ja, wij leveren van 10 tot 10.000 stuks. Alles wordt in eigen productie gemaakt op ons atelier in Den Haag." },
  { q: "Kan ik ook als particulier bestellen?", a: "Ja, wij werken voor zowel bedrijven als particulieren. Iedereen is welkom." },
  { q: "Welke druktechnieken gebruiken jullie?", a: "Wij werken met zeefdruk, DTF printing, transferdruk en borduren. Elke techniek heeft zijn voordelen — wij adviseren graag welke het beste past bij jouw opdracht." },
  { q: "Wat is het verschil tussen bedrukken en borduren?", a: "Bedrukking is geschikt voor grote vlakken en fotoprints. Borduurwerk is duurzamer en geeft een hoogwaardige uitstraling, ideaal voor logo's op polo's en caps." },
  { q: "Is borduren duurder dan bedrukken?", a: "Borduren is iets duurder, maar bij Magic Print is de borduurkaart altijd gratis!" },
  { q: "Hoe lang is de levertijd?", a: "Dit hangt af van de opdracht en het aantal stuks. Neem contact op voor een snelle indicatie — wij werken flexibel en denken graag mee bij spoedopdrachten." },
  { q: "Leveren jullie ook buiten Den Haag?", a: "Ja, wij leveren door heel Nederland. Wij bedienen ook regio's zoals Voorburg, Rijswijk, Leidschendam en Zoetermeer." },
  { q: "Kan ik langskomen om een opdracht te bespreken?", a: "Ja, op afspraak bent u welkom op ons atelier aan de Platinaweg 25 in Den Haag." },
  { q: "Worden de producten in eigen productie gemaakt?", a: "Ja, 100%. Wij besteden niets uit. Daardoor hebben wij volledige controle over kwaliteit én kunnen wij scherpe prijzen bieden." },
];

const FAQ = () => (
  <section id="faq" className="py-20 md:py-28">
    <div className="container max-w-3xl">
      <div className="text-center mb-14">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2933]">
          Veelgestelde vragen
        </h2>
        <p className="text-muted-foreground">
          Alles wat u wilt weten over kleding bedrukken bij Magic Print.
        </p>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="bg-card border border-border rounded-xl px-6 data-[state=open]:border-primary/40 transition-colors"
          >
            <AccordionTrigger className="text-left font-medium hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
